<template>
<div>
<v-container fluid>
    <v-row justify="space-between">
        <v-col cols="6" class="text-left">
            <div v-if="is_admin" class="ml-2">
                <v-btn color="" class="mygreen white--text mr-5" @click="showDialog()">
                <img class="img" src="/img/icon_eigyobi_setting.svg" style="margin-left: -6px;margin-right:6px;" />
                <span>営業日設定(月毎)</span></v-btn>
            </div>
        </v-col>

        <v-col cols="6" class="">
            <v-row justify="end">
                <v-col cols="4" class="text-right d-flex align-end  flex-wrap"> </v-col>
                <v-col cols="8" class="text-right d-flex align-end  flex-wrap">
                    <v-row justify="end">
                        <!-- 年月 -->
                        <v-select
                            v-model="selected_year"
                            :items="arr_year"
                            item-text="text"
                            item-value="value"
                            outlined
                            @change="change_year_month()"
                            placeholder="選択してください"
                            style="max-width: 140px; margin-right: 32px;"
                        ></v-select>

                        <!-- 年月 -->
                        <v-select
                            class="text-right"
                            v-model="selected_month"
                            :items="arr_month"
                            outlined
                            @change="change_year_month()"
                            placeholder="選択してください"
                            style="max-width: 140px; margin-right: 32px;"
                        ></v-select>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</v-container>


<!-- シフトテーブル -->
<v-container fluid>
<table v-if="saibyouga">
<thead>
    <tr>
    <td style="position: sticky; top:0; left:0; z-index:1;" :class="{is_eigyoubi: is_eigyoubi}"></td>
    <td v-for="v in cal_data"
    :key="v.req"
    v-html="v.day"
    :class="{is_today_on: v.is_today && is_eigyoubi, is_today_off: v.is_today && !is_eigyoubi, is_eigyoubi: is_eigyoubi, is_sat: v.is_sat, is_sun: v.is_sun}"
    >
    </td>
    </tr>
</thead>

<!-- スタッフシフト表示部分 -->
<tbody>
    <tr v-for="v in staff_list"
    :key="v.id"
    >
      <td style="background:#fff; position: sticky; top:0; left:0; z-index:1;">
      <a v-if="is_eigyoubi && ( user.auth=='管理者' || (user.id==v.id && isDeadline()) )"  style="text-decoration:underline;" @click.stop.prevent="showDialogStaff(v.id, v.name)">{{ v.name }}</a>
      <span v-else>{{ v.name }}</span>
      </td>

      <!-- スタッフごとのシフト -->
      <td v-for="(vv,index) in cal_data"
      :key="vv.req"
      :class="{off: vv.is_today}"
      >
      <div :data-first="v.id + '-' + index" :class="{'first':true,  'gray': !vv.first}" >
          <div v-if="!!vv.first && hasShiftData(v.id, index, 'first')" v-html="formatShiftTime(getShiftData(v.id, index, 'first'))"></div>
      </div>
      <div :data-second="v.id + '-' + index" :class="{'second':true, 'gray': !vv.second}">
          <div v-if="!!vv.second && hasShiftData(v.id, index, 'second')" v-html="formatShiftTime(getShiftData(v.id, index, 'second'))"></div>
      </div>
      </td>
    </tr>
</tbody>

</table>
</v-container>

<DialogEigyoubi @tourokuEigyoubi="tourokuEigyoubi()" @closeDialog="closeDialog($event)" :dialogFlag="dialogFlag" :data="{text:''}" :year_month="year_month" :oya_eigyoubi="eigyoubi" :selected_date="selected_date"></DialogEigyoubi>
<DialogEigyoubiStaff @tourokuEigyoubiStaff="tourokuEigyoubiStaff()" @closeDialogStaff="closeDialogStaff($event)" :dialogFlag="dialogFlagStaff" :staff_name="staff_name" :staff_id="staff_id" :data="{text:''}" :year_month="year_month" :oya_eigyoubi_staff="eigyoubi_staff"></DialogEigyoubiStaff>


<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      timeout="4000"
      vertical
      :top="snackbarTop"
      :bottom="snackbarBottom"
      right
      outlined
      :style="snackbarStyle"
    >
      <div v-html="snackbar_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>

    <!-- 2発目用: 1発目のすぐ下に表示（固定オフセット） -->
    <v-snackbar
      v-model="snackbar2"
      timeout="4000"
      vertical
      top
      right
      outlined
      :style="snackbar2Style"
    >
      <div v-html="snackbar2_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar2 = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>
  </div>
</template>

<!-- 確認モーダル（営業日設定月毎のデザインに合わせる） -->
<v-dialog
  :value="confirmDialog"
  @click:outside="confirmDialog=false"
  width="460"
  max-width="460"
>
  <v-card class="rounded-lg">
    <v-toolbar class="mb-4 text-center" color="rgba(0, 189, 242, 1)" dark>
      <span class="text-center">確認</span>
    </v-toolbar>

    <v-card-text>
      <v-container class="mt-2">
        <v-row>
          <v-col cols="12" class="text-left">
            <div style="white-space: pre-line; width: 460px; color: #000 !important;">{{ confirmMessage }}</div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="pb-6">
      <v-spacer></v-spacer>
      <v-btn color="white" @click.stop.prevent="confirmCancel">キャンセル</v-btn>
      <v-btn dark color="rgba(0, 189, 242, 1)" @click.stop.prevent="confirmProceed">更新する</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
import DialogEigyoubi from '@/components/DialogEigyoubi.vue';
import DialogEigyoubiStaff from '@/components/DialogEigyoubiStaff.vue';
import moment from 'moment';
/* eslint-disable */


  export default {

    components:{
        DialogEigyoubi,
        DialogEigyoubiStaff
    },

    // datas
    data(){
        return {
           snackbar: false,
           snackbar_text: '更新しました',
           snackbarQueue: [],
           snackbarTop: true,
           snackbarBottom: false,
           snackbarStyle: {},
           snackbar2: false,
           snackbar2_text: '',
           snackbar2Style: {},
           confirmDialog: false,

            is_eigyoubi: false,
            // シフト管理画面右側の年月ドロップダウンの選択状態
            selected_year: ''+new Date().getFullYear(),
            selected_month:  (''+(new Date().getMonth()+1)).padStart(2, '0'),


            year_month: [
                {'text':'2022年1月', 'value': '2022-01-01'},
                {'text':'2022年2月', 'value': '2022-02-01'},
                {'text':'2022年3月', 'value': '2022-03-01'},
                {'text':'2022年4月', 'value': '2022-04-01'},
                {'text':'2022年5月', 'value': '2022-05-01'},
                {'text':'2022年6月', 'value': '2022-06-01'},
                {'text':'2022年7月', 'value': '2022-07-01'},
                {'text':'2022年8月', 'value': '2022-08-01'},
                {'text':'2022年9月', 'value': '2022-09-01'},
                {'text':'2022年10月', 'value': '2022-10-01'},
                {'text':'2022年11月', 'value': '2022-11-01'},
                {'text':'2022年12月', 'value': '2022-12-01'},
            ],
            arr_year: [{text:'2022年', value:'2022'},{text:'2023年', value:'2023'},{text:'2024年', value:'2024'},{text:'2025年', value:'2025'},{text:'2026年', value:'2026'},{text:'2027年', value:'2027'},{text:'2028年', value:'2028'},{text:'2029年', value:'2029'},{text:'2030年', value:'2030'}],
            arr_month: [{text:'01月', value:'01'},{text:'02月', value:'02'},{text:'03月', value:'03'},{text:'04月', value:'04'},{text:'05月', value:'05'},{text:'06月', value:'06'},{text:'07月', value:'07'},{text:'08月', value:'08'},{text:'09月', value:'09'},{text:'10月', value:'10'},{text:'11月', value:'11'},{text:'12月', value:'12'}],

            // この配列が作れればOK!
            staff_datas: {
                1: [ ['10:00<br>15:00','15:00<br>19:00'] ],
                2: [ ['11:00<br>15:00','15:00<br>19:00'] ],
                3: [ ['12:00<br>15:00','15:00<br>19:00'] ],
            },
            saibyouga: true,
            dialogFlag: false,
            dialogFlagStaff: false,
            staff_id: 0,
            staff_name: '',

            cal_data:[
                {req:'2022-01-01', day:'1/1<br>(土)',masu:[]},
                {req:'2022-01-02', day:'1/2<br>(日)',masu:[]},
                {req:'2022-01-03', day:'1/3<br>(月)',masu:[]},
                {req:'2022-01-04', day:'1/4<br>(火)',masu:[]},
                {req:'2022-01-05', day:'1/5<br>(水)',masu:[]},
                {req:'2022-01-06', day:'1/6<br>(木)',masu:[]},
                {req:'2022-01-07', day:'1/7<br>(金)',masu:[]},
                {req:'2022-01-08', day:'1/8<br>(土)',masu:['●', 'x', 'x', '●','●','●', 'x', '●','●','●', 'x', '●','●','●', 'x', '●','●','●', 'x', '●','●','●']},
            ],
            eigyoubi: [
                {id: 1, dayofweek:'月', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 2, dayofweek:'火', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 3, dayofweek:'水', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 4, dayofweek:'木', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 5, dayofweek:'金', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 6, dayofweek:'土', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 7, dayofweek:'日', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
            ],

            eigyoubi_staff: [
                {id: 1, dayofweek:'月', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 2, dayofweek:'火', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 3, dayofweek:'水', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 4, dayofweek:'木', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 5, dayofweek:'金', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 6, dayofweek:'土', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
                {id: 7, dayofweek:'日', first_check: 1, first_start: '09:00', first_end: '13:00', second_check: 1, second_start: '15:00', second_end: '20:00'},
            ],

            staff_list: [],
        }
    },  // datas



    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },


    created () {

      // スタッフのリストを取得
      axios.get('/get_staffs')
        .then((res) => {
              console.group();
              console.log('%c %s', mycolor.api, '/get_staffs');
              console.log(res.data);
              console.groupEnd();
              this.staff_list = res.data.filter( v => {
                    return v.id!=0;
                });

        })
        .catch(() => {
          // eslint-disable-next-line
          console.error();
        });

        this.isEigyoubi();  // 月毎営業日の存在確認
        this.getStaffDatas();
        this.getCalendar();
    },
    mounted () {
      console.log('mounted');
    },

    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),

        selected_date(){
            return  this.selected_year+'-'+this.selected_month+'-01';
        },
        confirmMessage(){
            const ym = `${this.selected_year}年${this.selected_month}月`;
            return [
                '※営業日を変更しようとしています。',
                '',
                'シフト設定済みの場合、シフトと勤怠表が影響を受けます。',
                '',
                '1. チェックを外した場合',
                '   該当日の該当枠は空欄で上書きされます。',
                '',
                '2. チェックをつけた場合',
                '   一度空欄になった枠は空欄のまま（自動で復元しません）。',
                '',
                `【対象】${ym}`,
                '',
                '続行しますか？',
            ].join('\n');
        }
    },
    methods: {
        enqueueSnackbar(msg, opts={}){
            const pos = opts.pos || 'top';
            const offset = opts.offset || 0;
            const parallel = !!opts.parallel;
            const item = { text: msg, pos, offset };
            if(parallel){
                // 2発目など、同時表示したい場合はこちらに流す
                this.showSecondarySnackbar(msg, { offset });
                return;
            }
            if(this.snackbar){
                this.snackbarQueue.push(item);
            }else{
                this.applySnackbarItem(item);
            }
        },
        applySnackbarItem(item){
            this.snackbar_text = item.text;
            // position
            this.snackbarTop = item.pos !== 'bottom';
            this.snackbarBottom = item.pos === 'bottom';
            // offset via margin
            if(this.snackbarTop && item.offset){
                this.snackbarStyle = { marginTop: `${item.offset}px` };
            }else if(this.snackbarBottom && item.offset){
                this.snackbarStyle = { marginBottom: `${item.offset}px` };
            }else{
                this.snackbarStyle = {};
            }
            this.snackbar = true;
        },
        showSecondarySnackbar(msg, opts={}){
            const offset = opts.offset || 0;
            this.snackbar2_text = msg;
            this.snackbar2Style = offset ? { marginTop: `${offset}px` } : {};
            this.snackbar2 = true;
        },

        isDeadline(){
            let mydate = moment(this.selected_year + '-' + this.selected_month + '-15' ).add(-1, 'months');   // 前月の15日
            let currentDate = moment();  // 現在日時
            console.log(mydate._d);
            if( mydate.isBefore(currentDate) ){
                return false

            }else{
                return true;
            }
        },
        isEigyoubi(){
            // その月の月毎営業日が設定済みかどうかを返す.
            console.log('isEigyoubi()');

            axios.get( '/is_eigyoubi_kobetu/'+this.selected_year+'/'+this.selected_month )
            .then((res) => {
                console.group();
                console.log('%c %s', mycolor.api,  '/is_eigyoubi_kobetu/'+this.selected_year+'/'+this.selected_month);
                console.log(res.data);
                console.groupEnd();

                this.is_eigyoubi = res.data;
            })
            .catch(() => {
              // eslint-disable-next-line
              console.error();
            });
        },

        // 年月のドロップダウン変更
        change_year_month(){
            console.log('change_year_month()');
            console.log('this.selected_year', this.selected_year);
            console.log('this.selected_month', this.selected_month);
            this.getCalendar();
            this.getStaffDatas();
            this.isEigyoubi();
        },


        closeDialog(){
            console.log('closeDialog()');
            this.dialogFlag = false;
        },
        closeDialogStaff(){
            console.log('closeDialogStaff()');
            this.dialogFlagStaff = false;
        },

    async showDialog(){
        console.group();
        console.log('showDialog()');
        console.log('selected_date', this.selected_date);
        console.groupEnd();

        if( this.user.auth!=='管理者' && this.user.auth!=='チーフ' ){
            return false;
        }
        // 先に最新の営業日を取得してからモーダルを表示
        try{
            await this.getEigyoubi();
        }catch(e){ /* noop */ }
        this.dialogFlag = true;
    },
    async showDialogStaff(id, staff_name){
        console.log('showDialogStaff()');
        this.staff_id = id;
        this.staff_name = staff_name;
        // 先にスタッフのシフトを取得してからモーダルを表示（ちらつき防止）
        try{
            await this.getEigyoubiStaff(id);
        }catch(e){ /* noop */ }
        this.dialogFlagStaff = true;
    },
    tourokuEigyoubi(){
        console.log('tourokuEigyoubi()');
        console.log('oya_eigyoubi', this.eigyoubi);

        // 設定済みなら確認モーダルを表示、未設定なら即更新
        if (this.is_eigyoubi) {
          this.confirmDialog = true;
          return false;
        }

        this.doUpdateEigyoubi();



// 基本リアクティブなので不要
        // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
//        this.saibyouga = false;
//        this.$nextTick( () => (this.saibyouga = true) );
    },
    doUpdateEigyoubi(){
        const api = '/update_eigyoubi_kobetu/' + this.selected_year + '' + this.selected_month;
        axios.post(api, this.eigyoubi)
          .then((res) => {
            console.log(`%c ${api}`, mycolor.api);
            console.log(res.data);
            this.getCalendar();
            this.isEigyoubi();
            this.getStaffDatas();

            const ym = `${this.selected_year}年${this.selected_month}月`;
            this.enqueueSnackbar(`${ym}の営業日を更新しました`, { pos: 'top' });

            try{
              const names = (res.data && res.data.affected_staff) ? res.data.affected_staff : [];
              if(Array.isArray(names) && names.length>0){
                const listText = names.join(', ');
                const count = names.length;
                const msg2 = `${ym}影響スタッフ(計${count}名): ${listText}`;
                this.enqueueSnackbar(msg2, { pos: 'top', offset: 72, parallel: true });
              }
            }catch(e){}
          })
          .catch(() => {
            console.error();
          })
          .finally(()=>{
            this.closeDialog();
            this.confirmDialog = false;
          });
    },
    tourokuEigyoubiStaff(){
        console.log('tourokuEigyoubiStaff()');
        console.log('oya_eigyoubi', this.eigyoubi_staff);

        axios.post( '/update_eigyoubi_staff', this.eigyoubi_staff )
        .then((res) => {
          console.group();
          console.log('%c %s', mycolor.api, '/update_eigyoubi_staff');
          console.log(res.data);
          console.groupEnd();


          this.getStaffDatas();
        })
        .catch( (e) => {
          console.error(e);
        });

        this.closeDialogStaff();

        // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
        this.saibyouga = false;
        this.$nextTick( () => (this.saibyouga = true) );

        const ym2 = `${this.selected_year}年${this.selected_month}月`;
        this.snackbar = true;
        this.snackbar_text = `${ym2} [${this.staff_name}]さんのシフトを更新しました`;
    },
    getCalendar(){
        console.log('getCalendar()');

        let api = '/get_shiftcalendar/' + this.selected_year+''+this.selected_month;
        axios.get(api)
          .then((res) => {
            console.log('カレンダー取得')
            console.log(`%c${api}`, mycolor.api);
            this.cal_data = res.data;

            console.log('cal_data', this.cal_data);
          })
          .catch(() => {
            console.error();
          });

    },

    // スタッフのシフトデータを取得するヘルパー関数
    getShiftData(staffId, index, period) {
        if (!this.staff_datas[staffId] ||
            !this.staff_datas[staffId][index] ||
            !this.staff_datas[staffId][index][period]) {
            return null;
        }
        return this.staff_datas[staffId][index][period];
    },

    // シフトデータが存在するかチェックするヘルパー関数
    hasShiftData(staffId, index, period) {
        return !!this.getShiftData(staffId, index, period);
    },

    // シフト時間を表示用にフォーマットする関数
    formatShiftTime(shiftData) {
        if (!shiftData) return '';

        // 新しいAPIレスポンス形式に対応
        if (typeof shiftData === 'object' && shiftData.start && shiftData.end) {
            return `${shiftData.start}<br>${shiftData.end}`;
        }

        // 古い形式のデータにも対応（移行期間用）
        if (typeof shiftData === 'string' && shiftData.includes('<br>')) {
            return shiftData;
        }

        return '';
    },

    // スタッフのシフト情報を取得（修正版）
    getStaffDatas() {
        console.log('getStaffDatas()');
        var api = '/get_staff_datas';
        axios.post(api, {
            year: this.selected_year,
            month: this.selected_month
        })
        .then((res) => {
            console.log('スタッフのシフト取得')
            console.log(`%c${api}`, mycolor.orange);
            this.staff_datas = res.data;
            console.log(res.data);
        })
        .catch((error) => {
            console.error('スタッフデータ取得エラー:', error);
        });
    },

    // 営業日を取得
    getEigyoubi(){
        console.log('getEigyoubi()');
        return axios.get('/get_eigyoubi_kobetu/'+this.selected_date)
          .then((res) => {
            console.log('営業日の辞書取得');
            this.eigyoubi = res.data;
            console.log('this.eigyoubi', this.eigyoubi);
          })
          .catch(() => {
            // eslint-disable-next-line
            console.error();
          });
    },



    // スタッフのシフトを取得
    getEigyoubiStaff(staff_id){
        console.log('getEigyoubiStaff()');
        console.log('staff_id: ', staff_id);

        let api = '/get_eigyoubi_staff/'+staff_id;
        return axios.post(api, {_year: this.selected_year, _month: this.selected_month})
          .then((res) => {
            console.log('スタッフのシフト取得');
            console.log(res.data);
            this.eigyoubi_staff = res.data;
          })
          .catch(() => {
            // eslint-disable-next-line
            console.error();
          });
    },




      onResize() {
        console.log('onResize');
        console.log(this);
        this.tableHeight = window.innerHeight - 300;
      },


      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      // 確認モーダルの操作
      confirmProceed(){
        this.doUpdateEigyoubi();
      },
      confirmCancel(){
        this.confirmDialog = false;
      },

    },
    watch: {
      snackbar(newVal){
        // v-snackbar が閉じたタイミングでキューに残っていれば次を表示
        if(newVal===false && this.snackbarQueue && this.snackbarQueue.length>0){
          const next = this.snackbarQueue.shift();
          // 少し遅延して重なりを確実に避ける
          setTimeout(()=>{
            this.applySnackbarItem(next);
          }, 150);
        }
      }
    },

  }
</script>


<style scoped>
table{
background: white;
}
table{
  border-collapse:collapse;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
}
table th{
  border:1px solid #DCDDEE;
  background:royalblue;
}
table td{
  border:1px solid #DCDDEE;
  background:#ffffff;
  min-width: 140px;
  height: 66px;
}
.gray{
  background:#ECEDF6;
}
.first{
    height: 100%;
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
    border-right: 1px dashed #ccc;
    justify-content: center;
}
.second{
    height: 100%;
    width: 50%;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
}
/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot{
    background: #fff;
}
.is_eigyoubi{
    background: rgba(0, 189, 242, 1) !important;
    color: #fff;
    font-weight: bold;
}
.is_today_on{
  background:#fff !important;
  color: #000;
  font-weight: bold;
}
.is_today_off{
  background:rgba(0, 189, 242, 1) !important;
  color: #fff;
  font-weight: bold;
}
.is_sat{
  color: #4285F4;
}
.is_sun{
  color: #E65C52;
}
/deep/ .v-text-field.v-text-field--enclosed .v-text-field__details{
    display: none;
}
/deep/ .v-input__control{
    height: 50px !important;
}
.v-application a {
    font-size: 14px !important;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
